<template>
    <div>
        <top-nav v-if="stageType==1" :active="'/asmt/index'"></top-nav>
        <mobileTopNav v-if="stageType==2" title="心理测评"></mobileTopNav>

        <div class="mw arCenter">
            <div class="asmtTop">
                <div class="asmtImg" v-if="record.asmt.cover" :style="'background-image: url('+fileHost+record.asmt.cover+')'"></div>
                <div class="asmtDesc">
                    <div class="asmtName">{{ record.asmt.asmtName }}</div>
                    <div class="asmtDay" v-if="record.asmtOrg">{{ record.asmtOrg.beginTime }} ~ {{ record.asmtOrg.endTime }}</div>
                    <div class="asmtDay" v-else>{{ record.asmt.beginTime }} ~ {{ record.asmt.endTime }}</div>
                    <div class="asmtOverNum">{{ record.asmt.numTotal }} 参与</div>
                </div>
            </div>
            <div class="clear0"></div>

            <div class="scaleBlock">
                <div class="blockTitRow">
                    <div class="blockTit">测评内容</div>
                </div>

                <div class="scaleItem" v-for="(n,i) in scaleList" :key="i">
                    <div :class="'siStatus sis'+n.overStatus">{{ n.overStatus?'已完成':'未完成' }}</div>
                    <div class="siAsmtName">{{ n.scaleName }}</div>
                    <div class="siQstNum" v-if="n.type==2">
                        <div class="siqni">已答题 {{ n.overNum }}</div>
                        <div class="siqni">未答题 {{ n.unNum }}</div>
                    </div>
                    <div class="siBot">
                        <el-button v-if="n.overStatus && n.type==2" type="success" size="medium" @click="showReport(n)">查看报告</el-button>
                        <el-button v-if="!n.overStatus" type="primary" size="medium" icon="el-icon-right" @click="toScale(n)">开始答题</el-button>
                    </div>
                </div>
            </div>

            <div class="clear20"></div>
        </div>

        <bot-nav v-if="stageType==1"></bot-nav>

        <el-dialog :title="centerDialogTit" :custom-class="dialogClass" :width="centerDialogWidth" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" :visible.sync="centerDialogVisible" :fullscreen="centerDialogFs"
            v-if="centerDialogVisible" append-to-body>
            <component :is="centerComp.con" :key="centerComp.ts" :param="centerComp.param" @closeCallback="centerDialogVisible=false" @confirmCallback="centerConfirmCallback"></component>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "asmt_record",
    components: {},
    data () {
        return {
            stageType: '',
            recordId: '',
            record: {
                asmt: {},
                asmtOrg: {},
            },
            fileHost: config.fileHost,

            scaleList: [],

            centerDialogTit: '',
            centerDialogWidth: '660px',
            dialogClass: '',
            centerDialogFs: false,
            centerDialogVisible: false,
            centerComp: {},
        };
    },
    methods: {
        centerConfirmCallback: function (param) {
            if (param && param.code) {
                if (param.code == 'cust_ok') {
                    this.centerDialogVisible = false;
                }
            }
        },
        loadRecord: function () {
            let _this = this;
            this.req('/pap_asmt_record?id=' + this.recordId + '&buildDetail=yes', {}, function (data) {
                if (data.success) {
                    _this.record = data.obj;
                    if (_this.record && this.record.asmtId) {
                        _this.loadScales();
                    }
                }
            }, 'get');
        },
        loadScales: function () {
            let _this = this;
            this.req('/pap_scale_by_asmt?cache=yes&asmtId=' + this.record.asmtId, {}, function (data) {
                if (data.success) {
                    _this.scaleList = data.obj;
                    _this.loadAsmtScales();
                }
            }, 'get');
        },
        loadAsmtScales: function () {
            let _this = this;
            this.req('/pap_asmt_scale_list', { recordId: this.recordId, qrySimple: true }, function (data) {
                if (data.success) {
                    let asMap = {};
                    data.obj.forEach(function (n) {
                        asMap[n.scaleId] = n;
                    });

                    _this.scaleList.forEach(function (n, i) {
                        let as = asMap[n.id];
                        if (as) {
                            n.overNum = as.qstNumOver;
                            n.unNum = as.qstNumTotal - as.qstNumOver;
                            n.overStatus = as.status;
                            n.overTime = as.overTime;
                        } else {
                            n.overNum = 0;
                            n.unNum = n.qstNum;
                            n.overStatus = 0;
                            n.overTime = '';
                        }
                        _this.$set(_this.scaleList, i, n);
                    });
                }
            });
        },
        toScale: function (n) {
            let allScales = this.scaleList.map(function (s) {
                return s.id + '_' + s.type;
            }).join(',');
            if (n.type == 1) {
                this.$router.push({ path: '/asmt/asmt_scale_paper_survey', query: { scaleId: n.id, recordId: this.recordId, allScales: allScales } });
            } else if (n.type == 2) {
                this.$router.push({ path: '/asmt/asmt_scale_flow', query: { scaleId: n.id, recordId: this.recordId, allScales: allScales } });
            }
        },
        showReport: function (n) {
            this.centerComp = {
                con: () => import('@/components/asmt/asmt_scale_report.vue'),
                ts: new Date().getTime(),
                param: {
                    scaleId: n.id,
                    recordId: this.recordId,
                    showResult: this.record.asmt.showResult,
                    showSuggest: this.record.asmt.showSuggest,
                    overTime: n.overTime,
                },
            };
            this.centerDialogTit = n.scaleName;
            this.centerDialogWidth = this.lib.popWidth(660, 0.9);
            this.dialogClass = '';
            this.centerDialogVisible = true;
        },
    },
    mounted: function () {
        this.$nextTick(function () {
            let _this = this;
            this.stageType = sessionStorage.getItem("stageType");
            this.recordId = this.$route.query.recordId;

            this.loadRecord();
        });
    },
    beforeDestroy: function () {
    },
};
</script>
<style scoped>
.arCenter {
    padding-top: 20px;
}
.asmtTop {
    display: flex;
    gap: 20px;
}
.asmtImg {
    width: 380px;
    height: 210px;
    background-size: cover;
    background-position: center;
    border-radius: 10px;
}
.asmtDesc {
    flex: 1;
    padding-top: 15px;
}
.asmtName {
    font-size: 20px;
    font-weight: bold;
}
.asmtDay {
    margin-top: 15px;
    color: #888;
}
.asmtOverNum {
    font-size: 18px;
    margin-top: 15px;
}

.blockTitRow {
    height: 50px;
    line-height: 48px;
    margin-top: 20px;
    margin-bottom: 10px;
}
.blockTit {
    color: #077cf5;
    width: auto;
    float: left;
    border-bottom: 2px solid #077cf5;
}

.scaleItem {
    width: 373px;
    height: 210px;
    background-color: #077cf522;
    float: left;
    margin-right: 20px;
    margin-bottom: 20px;
    border-radius: 10px;
    position: relative;
    box-sizing: border-box;
    padding: 20px 20px;
}
.siStatus {
    width: 90px;
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
    text-align: center;
}
.sis0 {
    background-color: #e6a23c;
    color: #fff;
}
.sis1 {
    background-color: #67c23a;
    color: #fff;
}
.siAsmtName {
    margin-top: 10px;
    font-size: 20px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.siQstNum {
    display: flex;
    margin-top: 10px;
}
.siqni {
    flex: 1;
    font-size: 14px;
    color: #666;
}
.siBot {
    text-align: right;
    width: 200px;
    height: 32px;
    position: absolute;
    z-index: 1;
    right: 20px;
    bottom: 20px;
}
/* 媒体查询：当屏幕宽度小于770px时的样式 */
@media (max-width: 770px) {
    .asmtTop {
        flex-direction: column;
        gap: 15px;
        padding: 15px;
    }

    .asmtImg {
        width: 100%;
        height: 200px;
        border-radius: 8px;
    }

    .asmtDesc {
        padding-top: 0;
    }

    .asmtName {
        font-size: 20px;
    }

    .scaleBlock {
        padding: 0 15px;
    }
    .scaleItem {
        width: 100%;
        float: none;
        margin-right: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/asmt/asmt_record.vue